import {
  FETCH_KITCHENDINING_SURVEY_LIST_REQUEST,
  FETCH_KITCHENDINING_SURVEY_LIST_SUCCESS,
  FETCH_KITCHENDINING_SURVEY_LIST_FAILURE,
  FETCH_KITCHENDINING_SURVEY_DETAIL_REQUEST,
  FETCH_KITCHENDINING_SURVEY_DETAIL_SUCCESS,
  FETCH_KITCHENDINING_SURVEY_DETAIL_FAILURE,
  FETCH_KITCHENDINING_USER_SURVEY_LIST_REQUEST,
  FETCH_KITCHENDINING_USER_SURVEY_LIST_SUCCESS,
  FETCH_KITCHENDINING_USER_SURVEY_LIST_FAILURE,
} from "../actions/kitchenDiningSurveyActions";

const initialState = {
  loading: false,
  kitchenDiningSurveyList: [],
  kitchenDiningUserSurveyList: [],
  kitchenDiningSurveyDetail: null,
  error: null,
};

const kitchenDiningSurveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_KITCHENDINING_SURVEY_LIST_REQUEST:
    case FETCH_KITCHENDINING_SURVEY_DETAIL_REQUEST:
    case FETCH_KITCHENDINING_USER_SURVEY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_KITCHENDINING_SURVEY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        kitchenDiningSurveyList: action.payload,
      };

    case FETCH_KITCHENDINING_USER_SURVEY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        kitchenDiningUserSurveyList: action.payload,
      };

    case FETCH_KITCHENDINING_SURVEY_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        kitchenDiningSurveyDetail: action.payload,
      };

    case FETCH_KITCHENDINING_SURVEY_LIST_FAILURE:
    case FETCH_KITCHENDINING_SURVEY_DETAIL_FAILURE:
    case FETCH_KITCHENDINING_USER_SURVEY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default kitchenDiningSurveyReducer;
